import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actions from "MODULES/companies/actions";
import { Field, formValueSelector, FormSection } from "redux-form";
import {
  form,
  Form as AppForm,
  FormInput,
  Check,
  Select,
  PhoneNumberField
} from "MODULES/shared/components/Forms";
import { ShippingMethod } from "MODULES/shared/components/Forms/FormSections";
import { DashedSeparator } from "MODULES/shared/components";
import {
  BILLING_ADDRESS,
  COMPANY_TYPE,
  COMPANY_TYPES,
  CONTACT,
  WEBSITE
} from "MODULES/companies/constants";
import { toOptions } from "LIB/forms";
import { EMAIL, NAME, PHONE } from "APP_ROOT/constants";
import { properCase } from "LIB/formatters/text";
import { Col } from "react-bootstrap";
import validate from "./validate";
import AddressFields from "../AddressFields";
import PhysicalAddress from "./PhysicalAddress";

const FORM_NAME = "createCompany";

export function Form(props) {
  const requireContact =
    !props.getFieldValue(WEBSITE) ||
    [NAME, EMAIL].some(f => !!props.getFieldValue([CONTACT, f].join(".")));

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <div className="row">
          <Col md={4}>
            <div className="panel panel-default detail-panel">
              <div className="panel-body">
                <Field
                  name={COMPANY_TYPE}
                  component={Select}
                  label="Type"
                  options={toOptions(COMPANY_TYPES)}
                />
                <Field
                  name={NAME}
                  component={FormInput}
                  label={properCase(NAME)}
                  required
                />
                <PhoneNumberField
                  name={PHONE}
                  component={FormInput}
                  label={properCase(PHONE)}
                />
                <Field
                  name={WEBSITE}
                  component={FormInput}
                  label={properCase(WEBSITE)}
                />
                <DashedSeparator />
                <h5 className="h3">Primary Contact Info</h5>
                <Field
                  name={[CONTACT, NAME].join(".")}
                  component={FormInput}
                  label="Contact Name"
                  required={requireContact}
                />
                <Field
                  name={[CONTACT, EMAIL].join(".")}
                  component={FormInput}
                  label="Contact Email"
                  required={requireContact}
                />
                <PhoneNumberField
                  name={[CONTACT, PHONE].join(".")}
                  component={FormInput}
                  label="Contact Phone"
                />
                <DashedSeparator />
                <h5 className="h3">Status And Approval</h5>
                <div className="form-group">
                  <div
                    className="btn-group btn-group-justified btn-group-vertical"
                    data-toggle="buttons"
                  >
                    <Field
                      name="request_vendor_approval"
                      component={Check}
                      label="Request Vendor Approval"
                    />
                    <Field
                      name="request_shop_approval"
                      component={Check}
                      label="Request Rep Station Approval"
                    />
                  </div>
                </div>
              </div>
            </div>
          </Col>
          <Col md={8}>
            <h5 className="h3 modal-body-top">Billing Address</h5>
            <AddressFields
              path={BILLING_ADDRESS}
              country={props.country}
              region={props.region}
              formName={FORM_NAME}
              showRegion
              stateProvinceRequired
            />
            <DashedSeparator />
            <h5 className="h3">Physical Address</h5>
            <PhysicalAddress renderCheckbox />
            <DashedSeparator />
            <h5 className="h3 modal-body-top">Shipping Preference</h5>
            <FormSection name="shipping_method">
              <ShippingMethod required={false} />
            </FormSection>
          </Col>
        </div>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  country: PropTypes.string
};

const selector = formValueSelector(FORM_NAME);

export default connect(
  state => ({
    country: selector(state, "billing_address.country"),
    getFieldValue: field => selector(state, field)
  }),
  { onSubmit: actions.create }
)(
  form({
    form: FORM_NAME,
    validate,
    asyncValidate: actions.validateContact,
    asyncBlurFields: ["contact.email"]
  })(Form)
);



// WEBPACK FOOTER //
// ./app/modules/companies/components/CreateCompany/Form.jsx